import { render, staticRenderFns } from "./U15List.vue?vue&type=template&id=bc324e1e"
import script from "./U15List.vue?vue&type=script&lang=js"
export * from "./U15List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports